import { HelpFrame } from "@/components/help/help-frame"
import { SiteShell } from "@/components/layout/site-shell"
import { Skeleton } from "@anysola/ui/skeleton"

/** Breadcrumb, title, summary, then the body: the frame of `routes/help/$slug.tsx`. */
export function HelpArticleLoading() {
  return (
    <SiteShell>
      <HelpFrame>
        <div className="max-w-[42rem] space-y-8">
          <div>
            <Skeleton className="h-4 w-40" />
            <Skeleton className="mt-5 h-9 w-96 max-w-full" />
            <Skeleton className="mt-4 h-5 w-full max-w-xl" />
          </div>
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/5" />
          </div>
        </div>
      </HelpFrame>
    </SiteShell>
  )
}
